<template>
    <div>
        <slot :isDataLoading="isLoading"></slot>
    </div>
</template>

<script>
import {AutomationTypes} from '@/types/automations/types'
import {workflowApi} from '@/api/workflow'
import {ERROR} from '@/store/modules/ui/UI'
import {AutomationResourceTypes, automationsApi} from '@/api/automations'
import {AppDocSystemTypes} from '@/types/document/types'
import {AutomationFieldTypes} from '@/types/automations'
import {automationCategoryCustom} from '@/types/automations/categories'
import {fetchAutomationObjects} from '@/views/automation/data-provider/index'

export default {
    name: 'AutomationDataProvider',
    provide() {
        return {
            // extend with context later
            getAvailableConditions: this.getAvailableConditions,
            getAvailableActions: this.getAvailableActions,
            getAvailableObjects: this.getAvailableObjects,
            getObjectModelByName: this.getObjectModelByName,
            getAvailableObjectLabelsMap: this.getAvailableObjectLabelsMap,
            getAvailableCategories: this.getAvailableCategories,
            getAvailableApps: this.getAvailableApps
        }
    },
    data() {
        return {
            isLoading: false,

            categories: [],
            conditions: [],
            actions: [],

            globalProperties: [],
            objects: []
        }
    },
    methods: {
        getAvailableActions({type = AutomationTypes.AUTOMATION} = {}) {
            return this.actions
        },

        getAvailableCategories({type = AutomationTypes.AUTOMATION, withCustom = true}) {
            let categories = _.cloneDeep(this.categories)
            if (withCustom) {
                categories.push(automationCategoryCustom)
            }
            return categories
        },

        getAvailableConditions({type = AutomationTypes.AUTOMATION}) {
            return [
                {
                    name: 'New condition',
                    code: null,
                    uuid: null,
                    template: '{field} {operator} {value}',
                    field: {
                        type: AutomationFieldTypes.STRING
                    },
                    operator: {
                        default: null
                    },
                    values: []
                },
                ...this.conditions
            ]
        },

        getAvailableObjects() {
            return this.objects
        },

        getObjectModelByName(name) {
            return this.objects.find(o => o.name === name)
        },

        getAvailableObjectLabelsMap() {
            return this.objects.reduce((acc, o) => {
                acc[o.name] = o.label
                return acc
            }, {})
        },

        getAvailableGlobalProperties() {
            return this.globalProperties
        },

        getAvailableApps() {
            return []
        },

        async fetchData() {
            this.isLoading = true
            await Promise.all([
                this.fetchAutomationCategories(),
                this.fetchConditions(),
                this.fetchActions(),
                this.fetchGlobalProperties(),
                this.fetchAutomationObjects()
            ])
            this.isLoading = false
        },

        async fetchConditions() {
            const {data} = await automationsApi.fetchAllResources({
                section: AppDocSystemTypes.PURCHASING,
                type: AutomationResourceTypes.CONDITION_TEMPLATE
            })
            this.conditions = data
                .map(r => ({uuid: r.uuid, ...r.payload}))
                .sort((a, b) => a.name.localeCompare(b.name))
        },

        async fetchActions() {
            const {data} = await automationsApi.fetchAllResources({
                section: AppDocSystemTypes.PURCHASING,
                type: AutomationResourceTypes.ACTION_TEMPLATE
            })
            this.actions = data
                .map(r => ({uuid: r.uuid, ...r.payload}))
                .sort((a, b) => a.name.localeCompare(b.name))
        },

        async fetchAutomationCategories() {
            const {data} = await automationsApi.fetchAllResources({
                section: AppDocSystemTypes.PURCHASING,
                type: AutomationResourceTypes.CATEGORY
            })
            this.categories = data.map(r => ({uuid: r.uuid, ...r.payload}))
        },

        async fetchAutomationObjects() {
            this.objects = await fetchAutomationObjects()
        },

        async fetchGlobalProperties() {
            const {data, error} = await workflowApi.fetchGlobalProperties()
            if (error) {
                this.$snackbar.show({type: ERROR})
            } else {
                this.globalProperties = data.map(p => p.config)
            }
        }
    },
    created() {
        this.fetchData()
    }
}
</script>
